import type { ElementType } from 'react';
import { pathJoin } from 'utils/general';

const ROOT_CATEGORIES = ['entertaining', 'groceries', 'offers'];

const INTERNAL_BROWSE_ROOT = '/ecom/shop/browse';

const generateBreadcrumbPath = ({
  baseUrl,
  breadcrumbUrlNames,
  index,
}: {
  baseUrl: string;
  breadcrumbUrlNames: string[];
  index: number;
}) => {
  const path = breadcrumbUrlNames
    .slice(0, index + 1)
    .join('/')
    .toLowerCase();

  const isRoot = ROOT_CATEGORIES.includes(path);

  return pathJoin(isRoot ? INTERNAL_BROWSE_ROOT : baseUrl, path);
};

type EmptyBreadcrumbs = never[];

type BreadcrumbsWithPath = Array<{
  component?: ElementType;
  name: string;
  path: string;
}>;

type BreadcrumbsWithUrlName = Array<{
  component?: ElementType;
  name: string;
  urlName: string;
}>;

export type Breadcrumbs = BreadcrumbsWithPath | BreadcrumbsWithUrlName | EmptyBreadcrumbs;

export const enrichBreadcrumbs = ({
  baseUrl = INTERNAL_BROWSE_ROOT,
  breadcrumbs,
}: {
  baseUrl?: string;
  breadcrumbs?: Breadcrumbs;
}) => {
  if (!breadcrumbs?.length) {
    return [];
  }

  const breadcrumbUrlNames = breadcrumbs.map(breadcrumb =>
    'urlName' in breadcrumb ? breadcrumb.urlName : '',
  );

  return breadcrumbs.map((breadcrumb, index) => ({
    ...breadcrumb,
    path:
      'path' in breadcrumb
        ? breadcrumb.path
        : generateBreadcrumbPath({ baseUrl, breadcrumbUrlNames, index }),
  }));
};
